export const TagListTypes = {
    USERS: 'USERS',
    LOCATIONS: 'LOCATIONS',
};
